var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"area","height":"400","options":_vm.computedChartOptions,"series":_vm.computedChartSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }